module.exports = __webpack_public_path__ + "static/media/chat07.78bca61b.gif";